/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:integration_id/fetch_product_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyFetchProductTags } from "./constants";
import type { GetAlloysPartnersShopifyFetchProductTagsResult } from "./types";
import { isGetAlloysPartnersShopifyFetchProductTagsResult } from "./validators";

export const getAlloysPartnersShopifyFetchProductTags = reactQueryFetcherAdapter(
  alloysPartnersShopifyFetchProductTags,
  (signal: AbortSignal, integrationId: string): Promise<GetAlloysPartnersShopifyFetchProductTagsResult> => {
    return fetch(`/alloys/partners/shopify/${integrationId}/fetch_product_tags`, "GET", {}, { signal });
  },
  isGetAlloysPartnersShopifyFetchProductTagsResult
);
